module.exports = {"id":"210321","name":"Romell Quioto","rating":"71","photo":"./data/images/photos/2/210321.png","club":{"name":"Houston Dynamo","logo":"./data/images/clubs/HoustonDynamo.png"},"positions":["AG","BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RomellQuioto0.json
// module id = 3705
// module chunks = 0